// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  display: flex;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--brand-bg);
  color: var(--brand-fg);
}

.shell-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* The header (phones and tablets): the lockup at 22 px, the menu at 44 px. */
.shell-topbar {
  flex: none;
  display: none;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: calc(56px + env(safe-area-inset-top, 0px));
  padding: env(safe-area-inset-top, 0px) 8px 0 20px;
  background: var(--brand-bg);
  transition:
    margin-top var(--dur-base) var(--ease-out),
    opacity var(--dur-fast) var(--ease-out),
    visibility 0s linear 0s;
}

.shell-brand {
  display: flex;
  align-items: center;
  min-width: 0;
  color: var(--brand-fg);
}

.shell-brand .apr-lockup {
  display: block;
  height: 22px;
  width: auto;
}

/* Reading on a phone (ChatView sets this through ShellChrome): the header
   slides up out of view by its own measured height and the conversation
   takes the room. visibility waits for the slide, then drops the button from
   the tab order; a scroll up brings the header straight back. */
.shell-main.tucked .shell-topbar {
  margin-top: calc(-1 * var(--shell-topbar-h, 56px));
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    margin-top var(--dur-base) var(--ease-out),
    opacity var(--dur-fast) var(--ease-out),
    visibility 0s linear var(--dur-base);
}

.shell-hamburger {
  position: relative;
  flex: none;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  color: var(--brand-fg);
}

.shell-hamburger:hover {
  background: var(--brand-surface-2);
}

.shell-dot {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--brand-fg);
  box-shadow: 0 0 0 2px var(--brand-bg);
}

.shell-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

@media (max-width: 900px) {
  .shell-topbar { display: flex; }
}

/* --- the unsaved-conversation dialog (shared dialog styles: main.css) --- */

.unsaved-hint {
  margin: 0 0 4px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.unsaved-link {
  padding: 0;
  font: inherit;
  color: var(--brand-fg);
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.unsaved-skip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 16px 0 0;
  min-height: 44px;
  font-size: 0.9375rem;
  line-height: 1.45;
  color: var(--brand-fg-read);
  cursor: pointer;
}

.unsaved-skip input {
  flex: none;
  margin-top: 1px;
}

.unsaved-policy {
  margin: 16px 0 0;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-subtle);
}

.unsaved-policy a {
  color: var(--brand-fg);
}

/* --- the sign-in overlay (sign in without losing the conversation) --- */

.auth-overlay {
  position: fixed;
  inset: 0;
  z-index: 90;
  overflow-y: auto;
  display: flex;
  /* flex-start, not center: a card taller than the screen (small phones,
     landscape) must scroll from its top, not overflow above the scroll
     origin where nobody can reach it. .auth-container (min-height: 100%)
     still centres the card whenever it fits. */
  align-items: flex-start;
  justify-content: center;
  background: var(--brand-scrim);
  /* Room above the card for the close button. */
  padding: calc(64px + env(safe-area-inset-top, 0px)) 12px 16px;
  animation: aprScrimIn var(--dur-fast) var(--ease-out);
}

.auth-overlay .auth-container {
  padding: 0 0 16px;
}

.auth-overlay-close {
  position: fixed;
  top: calc(12px + env(safe-area-inset-top, 0px));
  right: 12px;
  z-index: 95;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid var(--brand-line-control);
  background: var(--brand-bg);
  color: var(--brand-fg);
}

.auth-overlay-close:hover {
  background: var(--brand-surface-2);
}
`, "",{"version":3,"sources":["webpack://./src/components/AppShell.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kDAAkD;EAClD,iDAAiD;EACjD,2BAA2B;EAC3B;;;2BAGyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;;;gEAGgE;AAChE;EACE,kDAAkD;EAClD,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB;;;wCAGsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB,aAAa,EAAE;AACjC;;AAEA,6EAA6E;;AAE7E;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0EAA0E;;AAE1E;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb;;;+CAG6C;EAC7C,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,8CAA8C;EAC9C,6DAA6D;EAC7D,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+CAA+C;EAC/C,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".app-shell {\n  display: flex;\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n  background: var(--brand-bg);\n  color: var(--brand-fg);\n}\n\n.shell-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* The header (phones and tablets): the lockup at 22 px, the menu at 44 px. */\n.shell-topbar {\n  flex: none;\n  display: none;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  height: calc(56px + env(safe-area-inset-top, 0px));\n  padding: env(safe-area-inset-top, 0px) 8px 0 20px;\n  background: var(--brand-bg);\n  transition:\n    margin-top var(--dur-base) var(--ease-out),\n    opacity var(--dur-fast) var(--ease-out),\n    visibility 0s linear 0s;\n}\n\n.shell-brand {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  color: var(--brand-fg);\n}\n\n.shell-brand .apr-lockup {\n  display: block;\n  height: 22px;\n  width: auto;\n}\n\n/* Reading on a phone (ChatView sets this through ShellChrome): the header\n   slides up out of view by its own measured height and the conversation\n   takes the room. visibility waits for the slide, then drops the button from\n   the tab order; a scroll up brings the header straight back. */\n.shell-main.tucked .shell-topbar {\n  margin-top: calc(-1 * var(--shell-topbar-h, 56px));\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition:\n    margin-top var(--dur-base) var(--ease-out),\n    opacity var(--dur-fast) var(--ease-out),\n    visibility 0s linear var(--dur-base);\n}\n\n.shell-hamburger {\n  position: relative;\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  color: var(--brand-fg);\n}\n\n.shell-hamburger:hover {\n  background: var(--brand-surface-2);\n}\n\n.shell-dot {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--brand-fg);\n  box-shadow: 0 0 0 2px var(--brand-bg);\n}\n\n.shell-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n@media (max-width: 900px) {\n  .shell-topbar { display: flex; }\n}\n\n/* --- the unsaved-conversation dialog (shared dialog styles: main.css) --- */\n\n.unsaved-hint {\n  margin: 0 0 4px;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.unsaved-link {\n  padding: 0;\n  font: inherit;\n  color: var(--brand-fg);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n}\n\n.unsaved-skip {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 16px 0 0;\n  min-height: 44px;\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  color: var(--brand-fg-read);\n  cursor: pointer;\n}\n\n.unsaved-skip input {\n  flex: none;\n  margin-top: 1px;\n}\n\n.unsaved-policy {\n  margin: 16px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-subtle);\n}\n\n.unsaved-policy a {\n  color: var(--brand-fg);\n}\n\n/* --- the sign-in overlay (sign in without losing the conversation) --- */\n\n.auth-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 90;\n  overflow-y: auto;\n  display: flex;\n  /* flex-start, not center: a card taller than the screen (small phones,\n     landscape) must scroll from its top, not overflow above the scroll\n     origin where nobody can reach it. .auth-container (min-height: 100%)\n     still centres the card whenever it fits. */\n  align-items: flex-start;\n  justify-content: center;\n  background: var(--brand-scrim);\n  /* Room above the card for the close button. */\n  padding: calc(64px + env(safe-area-inset-top, 0px)) 12px 16px;\n  animation: aprScrimIn var(--dur-fast) var(--ease-out);\n}\n\n.auth-overlay .auth-container {\n  padding: 0 0 16px;\n}\n\n.auth-overlay-close {\n  position: fixed;\n  top: calc(12px + env(safe-area-inset-top, 0px));\n  right: 12px;\n  z-index: 95;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-bg);\n  color: var(--brand-fg);\n}\n\n.auth-overlay-close:hover {\n  background: var(--brand-surface-2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
